module.exports = __webpack_public_path__ + "assets/img/CP-2.d7ef29a3.jpg";